
riot.tag2('not-found', '  <div class="row">\n    <div class="col-md-12 text-center"><i class="fa fa-exclamation-triangle fa-5x text-danger"></i>\n      <div class="h4 text-danger">Страница не найдена</div>\n    </div>\n  </div>\n', '', '', function(opts) {
});


// WEBPACK FOOTER //
// ./pages/not-found.tag